import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthenticationSourceEnum } from '@app/v2/enums/authentication-source.enum';
import { UserServiceV2 } from '@app/v2/services/user-service/user.service';
import {
    MdsButtonComponent,
    MdsDialogActionsComponent,
    MdsDialogComponent,
    MdsDialogContentComponent,
} from '@medpacesoftwaredevelopment/designsystem';
import { AuthService } from '@services/auth/auth.service';
import { filter, shareReplay, switchMap } from 'rxjs';

@Component({
    selector: 'medpace-no-role-modal',
    templateUrl: './no-role-modal.component.html',
    styleUrls: ['./no-role-modal.component.scss'],
    imports: [AsyncPipe, MdsDialogComponent, MdsDialogActionsComponent, MdsDialogContentComponent, MdsButtonComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoRoleModalComponent {
    private readonly userService2 = inject(UserServiceV2);
    private readonly route = inject(Router);
    private readonly authService = inject(AuthService);
    private readonly dialogRef = inject(MatDialogRef<NoRoleModalComponent>);

    hasAccount$ = this.userService2.hasAccount.get$().pipe(shareReplay());

    user$ = this.hasAccount$.pipe(
        filter(Boolean),
        switchMap((_) => this.userService2.currentUserData.get$())
    );

    get claimsData() {
        return {
            email: this.authService.claims['email'],
            fullName: this.authService.claims['given_name'] + ' ' + this.authService.claims['family_name'],
        };
    }

    get isSSOAuthenticated() {
        const authenticationSource = <string>this.authService.claims['authenticationSource'];
        return authenticationSource === AuthenticationSourceEnum.SocialIdpAuthentication;
    }

    initLogout(): void {
        this.authService.logout();
    }

    accessReqeustPage(): void {
        this.dialogRef.close();
        this.route.navigate(['/access-request/sso']);
    }
}
